import {downloadCSVFiles} from '@/helpers/shadcn/utils'
import {
  downloadPromotionFileUploadErrors,
  downloadUploadedPromotionFile,
  getPromotionFileUploadHistory,
  getPromotionFileUploadErrors,
} from '@/services/promotionListService'
import {useQuery} from '@tanstack/react-query'
import {getBlobUrlWithSasToken} from '@/utils/urlUtils'

export const PROMOTION_UPLOAD_HISTORY_KEY = 'PROMOTION_UPLOAD_HISTORY'

const usePromotionUploadHistory = (enabled = false) => {
  // Fetches promotion upload history data using react-query
  const {data: promotionListUploadHistory} = useQuery({
    queryKey: [PROMOTION_UPLOAD_HISTORY_KEY],
    queryFn: () => getPromotionFileUploadHistory(),
    enabled: !!enabled, // Only fetch when the upload history modal is open
  })

  const uploadHistory = promotionListUploadHistory

  const getErrorTemplateFilename = () => {
    const date = new Date()
    const timestamp = date.toISOString().replace(/[-:]/g, '').replace('T', '_').split('.')[0]
    return `Upload_Error_Template_${timestamp}`
  }

  const downloadPromotionUploadError = async fileUUID => {
    const response = await downloadPromotionFileUploadErrors(fileUUID)

    await downloadCSVFiles(response, getErrorTemplateFilename())
  }

  // Funtion to download uploaded promotion file
  const downloadPromotionFile = async fileUUID => {
    try {
      const response = await downloadUploadedPromotionFile(fileUUID)
      const data = response?.data
      const downloadUrl = getBlobUrlWithSasToken(data) || `${data.blobUrl}${data.fileName}?${data.sasToken}`

      // Fetch the file
      const blobURL = await fetch(downloadUrl)

      if (!blobURL.ok) {
        const errorText = await blobURL.text()
        console.error('Download failed:', errorText)
        throw new Error(`Download failed: ${blobURL.status}`)
      }

      const blob = await blobURL.blob()

      // Create  and click download link
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = url
      link.download = data.fileName

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      URL.revokeObjectURL(url)

      return downloadUrl
    } catch (error) {
      console.error('Error downloading promotion file:', error)
      throw error
    }
  }

  return {
    uploadHistoryData: uploadHistory || [],
    downloadUploadError: downloadPromotionUploadError,
    downloadPromotionFile,
    getPromotionFileUploadErrors
  }
}

export default usePromotionUploadHistory
